export const getNewNotificationsCount = (notifications: { read: boolean }[]): number =>
  notifications.reduce((count, notification) => {
    if (!notification.read) {
      count += 1
    }
    return count
  }, 0)
